import apiClient from './client';

export interface FeedbackPayload {
  type: 'review' | 'feedback' | 'support';
  rating?: number;
  message: string;
  page_context?: string;
}

export async function submitFeedback(payload: FeedbackPayload): Promise<{ id: string }> {
  const res = await apiClient.post<{ id: string }>('/feedback', payload);
  return res.data;
}
